import { Badge, Box, Group, Text } from '@mantine/core';
import { useColors } from '../../../../../hooks/useColors';
import { ProjectExperience, ProjectRole } from '../../../../../types/cv';

interface ProjectExperienceBasicInfoProps {
  project: ProjectExperience;
}

export function ProjectExperienceBasicInfo({ project }: ProjectExperienceBasicInfoProps) {
  const colors = useColors();

  return (
    <Box>
      {project.technologies && project.technologies.length > 0 && (
        <Box mb="sm">
          <Text size="sm" fw={500} mb="xs">Skills & Technologies:</Text>
          <Group gap="xs">
            {project.technologies.map((personTech, index: number) => (
              <Badge
                key={index}
                size="sm"
                color={personTech.favourite ? colors.tech.FAVORITE_TECHNOLOGY : colors.tech.TECHNOLOGY}
                variant={personTech.favourite ? "filled" : "light"}
              >
                {personTech.technology?.name || 'Unknown Technology'}
              </Badge>
            ))}
          </Group>
        </Box>
      )}

      {project.roles && project.roles.length > 0 && (
        <Box>
          <Text size="sm" fw={500} mb="xs">Roles:</Text>
          <Group gap="xs">
            {project.roles.map((role: ProjectRole, roleIndex: number) => (
              <Badge
                key={roleIndex}
                size="sm"
                color={colors.tech.ROLE}
              >
                {role.name || 'Unknown Role'}
              </Badge>
            ))}
          </Group>
        </Box>
      )}
    </Box>
  );
} 